import script from "./CategoryTab.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryTab.vue?vue&type=script&setup=true&lang=js"

import "./CategoryTab.vue?vue&type=style&index=0&id=68cdedb6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68cdedb6"]])

export default __exports__